import PropTypes from 'prop-types';

const propTypes = {
  text: PropTypes.string,
  year: PropTypes.number,
  company: PropTypes.string,
  className: PropTypes.string,
};

function Copyright({
  text,
  year,
  company = 'Micruity Inc.',
  className = '',
}) {
  const currentYear = year || new Date().getFullYear();
  const copyrightText = text || `© Copyright ${currentYear} All Rights Reserved ${company}`;

  return (
    <div className={`footer__copyright ${className}`.trim()}>
      <span>{copyrightText}</span>
    </div>
  );
}

Copyright.propTypes = propTypes;

export default Copyright;

// Copyright © 2025 Micruity Inc.
